import React, {Component} from 'react';
import {connect} from 'react-redux'
import SearchForm from '../components/SearchForm'
import FileUtils from '../utils/FileUtils'
import update from 'immutability-helper';
import Lightbox from 'react-images';
import PaginationUnit from '../components/PaginationUnit'
import {SearchResult} from '../components/SearchResult'
import {loadData} from '../utils/operations'
import {Footer} from '../components/common/common'
import {changePageTitle} from "../i18n/localisations";
import ISpan from "../i18n/ISpan";

export let Header = (props) => {
    return <div id="header">
        <div id="header-top" className={"section clearfix"}>
            <ul id="secondary-menu" className={"links clearfix secondary-menu"}>
                <li className={"menu-996 first active"}><a href="https://tam-arkiv.se/" title="TAM Archive | Hem"
                                                           className={"active"}><font>Hem</font></a></li>
                <li className={"menu-629"}><a href="https://tam-arkiv.se/om-tam-arkiv/" title="Om TAM-Arkiv"> <font>Om TAM-Arkiv</font></a>
                </li>
                <li className={"menu-1154"}><a href="https://tam-arkiv.se/kontakt/"><font>Kontakt</font></a></li>
                <li className={"menu-1645 last"}><a href="https://tam-arkiv.se/about-tam-archives/"><font>In English</font></a>
                </li>
            </ul>
        </div>
        <div id="header-main" className={"section clearfix"}>
            <a href="/" title="Home" id="logo"> </a>
            <div id="name-and-slogan">
                <a href="#" title="Home" rel="home">
                    <div id="site-slogan">
                        <h1><ISpan defaultValue={props.title} localisationId={props.titleKey}/></h1>
                    </div>
                </a>
            </div>
        </div>
    </div>;
}

export let NoResultsFoundMessage = () => {
    return <div className={"no-results-container message-container"}>
        <h2 className={"pane-title"}><ISpan localisationId="common.messages.no_results_found.title" defaultValue="No results found."/></h2>
        <div><ISpan localisationId="common.messages.no_results_found.message" defaultValue="Please try again with a different search criteria."/></div>
    </div>
}


export class SearchResultsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isContentOnly: true,
            showSlideshow: false,
            currentImage: 0
        };

        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
        this.handleClickImage = this.handleClickImage.bind(this);
    }

    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }

    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    handleClickImage() {
        if (this.state.currentImage === this.getLightboxImages().length - 1) return;
        this.gotoNext();
    }

    static submit(values) {
        console.log("Performing search...");
        console.log(values);
    }

    render() {
        let searchResults = this.props.searchResults; //require('../mock/search-results-primary.json')
        let hasSearchResults = true;

        if (!searchResults) {
            hasSearchResults = false; //= (searchResults === null && !(searchResults.length === 0));
        } else {
            if (!(searchResults.length > 0)) {
                hasSearchResults = false;
            }
        }

        var lightboxImages = SearchUtils.getLightboxImages(this.props.searchResults);
        return <div className={"container"}><div className={"row"}>

            {this.getSearchBlock()}

            {
                this.props.searchError && <div className={"search-container container"}
                                               data-bind="with:searchResults, visible: searchResults().results() != 0, localize:searchResults">
                    <div>
                        <h2 className={"pane-title"}>
                            <ISpan localisationId="common.title.search_results" defaultValue="Unable to complete your request."/>
                        </h2>
                    </div>
                </div>
            }

            {
                this.props.hasSearchPerformed ? <div className={"eleven columns"}>
                    {/*Search Results*/}

                    {
                        (hasSearchResults) ?
                            <div className={"search-container container"}
                                 data-bind="with:searchResults, visible: searchResults().results() != 0, localize:searchResults">

                                {lightboxImages.length > 0 &&
                                <div style={{display: 'none'}}>
                                    <a href="#" onClick={() => {
                                        this.setState(update(this.state, {showSlideshow: {$set: true}}));
                                    }
                                    }><h2 className={"pane-title"}>View Slideshow</h2></a>
                                    <Lightbox currentImage={this.state.currentImage}
                                              images={lightboxImages}
                                              isOpen={this.state.showSlideshow}
                                              onClickImage={this.handleClickImage}
                                              onClickPrev={this.gotoPrevious}
                                              onClickNext={this.gotoNext}
                                              onClose={() => {
                                                  this.setState(update(this.state, {
                                                      showSlideshow: {$set: false}
                                                  }));
                                              }
                                              }
                                    />
                                </div>}

                                <div><h2 className={"pane-title"}><ISpan localisationId="common.title.search_results" defaultValue="Search Results"/></h2></div>
                                <div className={"search-results-container"} data-bind="foreach:results">
                                    {
                                        (searchResults.map((result) => {
                                            return this.getSearchResult(result);
                                        }))
                                    }
                                </div>

                                <PaginationUnit/>
                            </div> :
                            <div className={"search-container container"}
                                 data-bind="visible: searchResults().results() == 0">
                                <NoResultsFoundMessage/>
                            </div>
                    }

                </div> :
                    <div className={"eleven columns"}><ISpan localisationId="common.title.search_nosearch" defaultValue="You have not searched yet."/></div>
            }
        </div></div>
    }
}

export let SearchUtils = {
    getLightboxImages: (searchResults) => {
        let images = [];
        if (searchResults)
            searchResults.map(searchResult => {
                if (searchResult.thumbnailUrl && searchResult.thumbnailUrl.length > 0) {
                    images.push({
                        src: FileUtils.getAbsoluteUrl(searchResult.contentUrl),
                        caption: searchResult.title
                    })
                }
            });
        return images;
    }
};

export class PrimarySearchResultsPage extends SearchResultsContainer {

    constructor(props) {
        super(props);
        this.props.localise();
    }

    submit = (values) => {
        SearchResultsContainer.submit(values);
        this.props.loadData(values);
    };

    getSearchResult(result) {
        return <SearchResult key={Math.random()} item={result}/>
    }

    getSearchBlock() {
        return <div className={"five columns"}>
            <h2 className={"pane-title"}><ISpan localisationId="common.title.search" defaultValue="Search"/></h2>
            <SearchForm isContentOnly={this.state.isContentOnly} onSubmit={this.submit}/>
        </div>

    }
}

export class PageContainer extends Component {
    render() {
        return <div id="page">
            <Header titleKey={this.props.titleKey} title={this.props.title}/>
            <div id="main-wrapper">
                {this.props.children}
            </div>
            <Footer/>
        </div>
    }
}

export class PageContainerNoHeader extends Component {
    render() {
        return <div id="page-no-header">
            <div id="main-wrapper">
                {this.props.children}
            </div>
        </div>
    }
}
export default class PrimaryPageContainer extends PageContainer {
    render() {
        return <PageContainer title="Search Archive" titleKey="common.title.main_title">
            <PrimarySearchResultsPage/>
        </PageContainer>
    }
}

export let mapSearchResultsStateToProps = (state) => {
    return {
        searchResults: state.searchResults.results ? state.searchResults.results.results : null,
        searchError: state.searchResults.primarySearchError,
        paginationOptions: state.searchResults.results ? state.searchResults.paging : null,
        hasSearchPerformed: state.searchResults.hasSearchPerformed
    }
};


PrimarySearchResultsPage = connect(mapSearchResultsStateToProps, (dispatch) => {
    return {
        loadData: (searchValues) => dispatch(loadData(searchValues)),
        localise: () => dispatch(changePageTitle("common.title.main_title", "Search Archive"))
    }
})(PrimarySearchResultsPage);





// WEBPACK FOOTER //
// ./src/views/primary.js